import type { HeadingProps } from '@components/text/types/props';
import { Yeseva } from 'app/fonts';
import classNames from 'classnames';
import type { ReactElement } from 'react';
import React from 'react';
import { validateString } from 'utils/validate-string';

import styles from './text.module.scss';

const rootClass = validateString(styles.h4);
const responsiveClass = validateString(styles.responsive);

function H4({
  children,
  className,
  responsive = true,
  style,
}: HeadingProps): ReactElement {
  return (
    <h4
      className={classNames(rootClass, className, Yeseva.className, {
        [responsiveClass]: responsive,
      })}
      style={style}
    >
      {children}
    </h4>
  );
}

export default H4;
